import { render, staticRenderFns } from "./VesselParticularsMachinery.vue?vue&type=template&id=2b7bebda&"
import script from "./VesselParticularsMachinery.vue?vue&type=script&lang=js&"
export * from "./VesselParticularsMachinery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports